import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { getPharmacyInfoLocal } from '../../../api'
import distributorApi from '../../../api/distributor'
import { ORDER_STATUS_TEXT } from '../../../config/distributor'
import { LpFilter, LpWhere } from '../../../models/lp-filter'
import { IPharmacyOrder, IOrderStatus } from '../../../models/pharmacy-order'
import { useAsync } from '../../../utils'
import useViewModel from '../../../viewModel/base'
import Loading from '../../shared/Loading'

const CONFIG = {
    LIMIT: 10
}

type IKeySort = "ASC" | "DESC" | "NONE"

const DistributorOrders = () => {
    const history = useHistory()

    const { execute: getPharmacyOrder, status: getPharmacyOrderStatus } = useAsync(distributorApi.getPharmacyOrder)
    const { execute: getPharmacyOrderCount, value: count } = useAsync(distributorApi.getPharmacyOrderCount)

    const viewModel = useViewModel({
        mStatus: 'all' as IOrderStatus | 'all',
        sort: {
            feild: 'mCreated',
            order: 'DESC' as IKeySort
        },
        offset: 0,
        orders: [] as IPharmacyOrder[]
    })

    useEffect(() => {
        if (!viewModel.data.offset) return

        getPharmacyOrder(getFilterCondition()).then(res => {
            viewModel.updateData({
                orders: [
                    ...viewModel.data.orders,
                    ...res
                ]
            })
        })
    }, [viewModel.data.offset])

    useEffect(() => {
        getPharmacyOrderCount(getWhereCondition())
        getPharmacyOrder(getFilterCondition()).then(res => {
            viewModel.updateData({ orders: res })
        })
    }, [viewModel.data.sort, viewModel.data.mStatus])

    const getWhereCondition = (): LpWhere => {
        const pharmacy = getPharmacyInfoLocal()

        let where: LpWhere = {
            and: [{ mPharmacyId: pharmacy.pharmacyId }]
        };

        if (viewModel.data.mStatus != 'all') {
            where.and!.push({ mStatus: viewModel.data.mStatus })
        }

        if (!where.and?.length) {
            return {}
        }

        return where
    }

    const getFilterCondition = (): LpFilter => {
        const { offset } = viewModel.data
        const { feild, order } = viewModel.data.sort

        let filter: any = {
            offset: offset,
            limit: CONFIG.LIMIT,
            include: [{ relation: "mItems" }],
            where: getWhereCondition(),
            order: [`${feild} ${order}`]
        }

        return filter
    }

    const getViewStatus = (status: IOrderStatus) => {
        switch (status) {
            case 'APPROVING': return {
                text: ORDER_STATUS_TEXT.APPROVING,
                class: 'text-warning'
            }
            case 'APPROVED': return {
                text: ORDER_STATUS_TEXT.APPROVED,
                class: 'text-warning'
            }
            case 'FAIL': return {
                text: ORDER_STATUS_TEXT.FAIL,
                class: 'text-danger'
            }
            case 'SUCCESS': return {
                text: ORDER_STATUS_TEXT.SUCCESS,
                class: 'text-success'
            }

            default:
                break;
        }
    }

    const loadMore = () => {
        viewModel.updateData({
            offset: viewModel.data.offset + CONFIG.LIMIT
        })
    }

    return <div id="main">
        <div className="container">
            <div className="toolbar d-flex w-100 mt-3 align-items-center">
                <div className="w-50 pr-0 d-flex mr-3">
                    <label className="mt-2 mr-1"><b>TT</b></label>
                    <select
                        className="sort-by w-100"
                        onChange={e => {
                            viewModel.updateData({
                                offset: 0,
                                mStatus: e.target.value as IOrderStatus
                            })
                        }}
                    >
                        <option value='all'>Tất cả</option>
                        <option value='APPROVING'>{ORDER_STATUS_TEXT.APPROVING}</option>
                        <option value='APPROVED'>{ORDER_STATUS_TEXT.APPROVED}</option>
                        <option value='FAIL'>{ORDER_STATUS_TEXT.FAIL}</option>
                        <option value='SUCCESS'>{ORDER_STATUS_TEXT.SUCCESS}</option>
                    </select>
                </div>
                <div className="w-50 pl-0 d-flex">
                    <label className="mt-2 mr-1"><b>SX</b></label>
                    <select
                        className="sort-by w-100"
                        onChange={(e) => {
                            viewModel.updateData({
                                offset: 0,
                                sort: {
                                    feild: e.target.value,
                                    order: e.target.value === 'mTitle' ? 'ASC' : 'DESC'
                                }
                            })
                        }}
                    >
                        <option value='mCreated'>Ngày tạo</option>
                        <option value='mTitle'>Tên</option>
                    </select>
                </div>
            </div>
            {
                getPharmacyOrderStatus === 'loading' &&
                <div className="wrap-loading">
                    <Loading />
                </div>
            }
            {
                (getPharmacyOrderStatus === 'ready' && viewModel.data.orders.length === 0) ?
                    <div className="row bg-white d-flex justify-content-center order-list-empty">
                        <div className="text-center">
                            <img src="./images/no-order.svg" width={70} />
                            <p className="txt-gray mt-3 large-txt">Hiện không có đơn nào</p>
                        </div>
                    </div>
                    :
                    <div className="row">
                        <div className="table-orders mb-4">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Tên</th>
                                        <th scope="col" style={{ width: 80 }}>SL</th>
                                        <th scope="col" style={{ width: 110 }}>TT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        viewModel.data.orders?.map(item => {
                                            const viewStatus = getViewStatus(item.mStatus)
                                            const inventory = item.mItems && item.mItems[0]

                                            return <tr key={item.mId} onClick={() => history.push(`/distributor-order-info?orderId=${item.mId}`)}>
                                                <td>{item.mTitle}</td>
                                                <td>{inventory?.mTotalItems} {inventory?.mPkgName}</td>
                                                <td><span className={viewStatus?.class}>{viewStatus?.text}</span></td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                            {
                                viewModel.data.orders?.length < count &&
                                <div className="d-flex mt-2 justify-content-center">
                                    <button className="btn p-1 px-2" style={{ fontSize: 13 }} onClick={loadMore}>Xem thêm</button>
                                </div>
                            }
                        </div>
                    </div>
            }
        </div>
    </div>
}

export default DistributorOrders